
export class CatalogoTabla {
    idCatalogoTabla?: Number = -1;
    tipo?: String = "";
    valor?: string = "";
    tabla?: string = "";
    estatus?: string = "";
    idUsuarioUM?: Number = -1;
    tabreg?: Number = 0;
    playa?: number = 0;
    idCiudad?: number = 0;
    totalPorArea?: number = 0;
}
